<div class="workSpace" style="background-color: transparent; overflow: visible;">
  <div [style.height]="info.length > 0 ? '90%' : '100%'" class="" [id]="'grafica'+zona"></div>
  @if(info.length > 0){
    <div class="w3-row" style="margin-left: 20px;">
      <mat-icon class="iconoMen w3-button w3-dropdown-click material-icons-outlined" [ngStyle]="{'color':'gray'}">info</mat-icon>
      <span style="font-size: 8pt;">{{info}}</span>
    </div>
  }
</div>

<div [id]="'exportar'+zona" class="workSpace w3-white" style="overflow: hidden; top: 0px; left: 0; z-index: -200; position: absolute;">
  <div class="w3-row headers w3-titulo-contenidomenuSC" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
    <span class="w3-margin-left-contenido">{{tituloZona|translate}}</span>
    @if (subTituloZona) {
      <span class="w3-margin-left-contenido">&bull;</span>
      <span class="w3-margin-left-filter w3-subtitulo" matTooltip="{{subTituloZona}}">{{subTituloZona}}</span>
    }
  </div>
  <div class="containerGrafica">
    <div [id]="'graficaExport'+zona"></div>
  </div>
</div>

<div [id]="'exportarB'+zona" class="w3-white" style="top: 0px; left: 0; z-index: -2000; position: absolute; width: 60vw; height: 60vh;">
  <div class="containerGrafica">
    <div [id]="'graficaExportB'+zona"></div>
  </div>
</div>